import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed [\u0026_svg]:pointer-events-none [\u0026_svg]:size-4 [\u0026_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-brand-primary text-white shadow-xs hover:bg-brand-primary-70",
        destructive:
          "bg-error-light text-error-foreground shadow-2xs hover:bg-error-light/90 border border-transparent hover:border hover:border-error-foreground transition",
        destructiveOutline:
          "bg-transparent text-text-primary border border-transparent hover:bg-transparent hover:text-error-foreground transition",
        outline:
          "border bg-transparent shadow-2xs transition border-brand-primary hover:bg-brand-primary hover:text-white dark:border-border dark:text-text-primary dark:hover:bg-background-200 dark:hover:border-text-primary dark:hover:text-text-primary",
        secondary:
          "bg-secondary text-secondary-foreground shadow-2xs hover:bg-secondary/80 border border-transparent hover:border hover:border-border transition",
        ghost: "text-text-primary hover:bg-black/10 hover:text-white",
        link: "text-primary underline-offset-4 hover:underline",
        success:
          "bg-success-light text-success-foreground shadow-2xs hover:bg-success-light border border-transparent hover:border hover:border-success-foreground transition",
        info: "bg-info-light text-info-foreground shadow-2xs hover:bg-info-hover",
        warning:
          "bg-warning-light text-warning-foreground shadow-2xs hover:bg-warning-hover",
        muted:
          "bg-transparent border border-border text-text-primary hover:border-text-primary transition hover:bg-background-200",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
